import { PeoplePage } from "@drs-ops/access/frontend";
import { Navigate } from "@tanstack/react-router";
import { useIsAdmin } from "@/auth/useIsAdmin";

/** The shared @drs-ops/access People page. The admin check is a UI hint; the Worker enforces it. */
export function AdminPeoplePage(): React.ReactElement {
  if (!useIsAdmin()) return <Navigate to="/" />;
  return <PeoplePage />;
}
